import { useEffect, useRef } from "react";

const useInactivity = (onTimeout, timeout = 900 * 1000) => {
    const timeoutRef = useRef(null);
    const referenciaTimeoutInicial = useRef(null);

    const updateLastActivity = () => {
        const now = Date.now();
        localStorage.setItem("lastActivity", now.toString());
    };

    const handleTimeout = () => {
        localStorage.removeItem("lastActivity");
        onTimeout();
    };

    const checkGlobalInactivity = () => {
        const lastActivityStr = localStorage.getItem("lastActivity");
        if (!lastActivityStr) {
            return false;
        }
        const lastActivity = parseInt(lastActivityStr, 10);
        const now = Date.now();

        if (now - lastActivity > timeout) {
            handleTimeout();
            return true;
        }
        return false;
    };

    useEffect(() => {
        // Actualizar el timestamp en `localStorage` al detectar actividad del usuario
        const activityHandler = () => updateLastActivity();

        // Agregar listeners de actividad
        window.addEventListener("mousemove", activityHandler);
        window.addEventListener("keydown", activityHandler);
        window.addEventListener("click", activityHandler);
        window.addEventListener("scroll", activityHandler);

        // Ejecutar chequeo inmediato de inactividad
        const wasInactive = checkGlobalInactivity();

        // Solo si NO estaba inactivo, inicializar el timestamp tras un pequeño delay
        if (!wasInactive) {
            referenciaTimeoutInicial.current = setTimeout(() => {
                updateLastActivity();
            }, 1000);
        }

        timeoutRef.current = setInterval(checkGlobalInactivity, 1000);

        return () => {
            // Limpiar listeners y el intervalo al desmontar
            window.removeEventListener("mousemove", activityHandler);
            window.removeEventListener("keydown", activityHandler);
            window.removeEventListener("click", activityHandler);
            window.removeEventListener("scroll", activityHandler);
            clearInterval(timeoutRef.current);
            clearTimeout(referenciaTimeoutInicial.current);
        };
    }, [timeout, onTimeout]);
};

export default useInactivity;
